import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export class ProductOurStylistSuggests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  populateCurrentOSSAccessories() {
    var imageToCheckAgainst = this.props.selectedMainImg;
    var returnAccessories;
    if (this.state.OSSView && this.state.OSSView.accessories) {
      for (var i = 0; i < this.state.OSSView.accessories.length; i++) {
        var thisAccessoryObject = this.state.OSSView.accessories[i];
        if (thisAccessoryObject.dil_oss_product_image_name == imageToCheckAgainst) {
          returnAccessories = thisAccessoryObject.dil_oss_accessories;
        }
      }
    }
    return returnAccessories;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.contentData.productId != nextProps.contentData.productId) {
      this.fetchOSS(nextProps.contentData.productId, nextProps.contentData.dept, nextProps.contentData.mic);
    }
  }

  render() {
    var currentOSSAccessories = this.state.OSSView && this.populateCurrentOSSAccessories();
    this.props.passedFunctions.setCurrentOSSAccessories(currentOSSAccessories);
    var slidesToShow = 2;
    if (this.props.passedAppFunctions.siteFormat == 'tablet' || this.props.passedAppFunctions.siteFormat == 'mobile') {
      slidesToShow = 2.5;
    }

    return (
      <React.Fragment>
        {this.state.OSSView && currentOSSAccessories ? (
          <div
            className={`our-stylist-suggests ${this.state.OSSView && currentOSSAccessories && currentOSSAccessories.length > 2 ? 'has-multi' : ''}`}
            role='region'
            aria-label='Complete Your Look'
          >
            <h2 className='relative'>
              <span className='our-stylist-suggests-title'>Complete Your Look</span>
            </h2>

            {currentOSSAccessories.map((currentOSSAccessory, index) => (
              <div className='item cylImageContainer' key={currentOSSAccessory.dil_oss_acc_fullImage}>
                <Link
                  to={{
                    pathname: `/p/${currentOSSAccessory.dil_oss_acc_keyword}/${currentOSSAccessory.dil_oss_acc_catentry_id}`,
                    state: { qv: true, extraQVProps: { OSS: currentOSSAccessories } },
                  }}
                >
                  <img
                    src={`//dimg.dillards.com/is/image/DillardsZoom/nav/${currentOSSAccessory.dil_oss_acc_keyword}/${currentOSSAccessory.dil_oss_acc_fullImage}.jpg`}
                    alt={currentOSSAccessory.dil_oss_acc_name}
                    height='196'
                    width='169'
                  />
                </Link>

                <Link
                  className='btn btn-secondary btn-block'
                  to={{
                    pathname: `/p/${currentOSSAccessory.dil_oss_acc_keyword}/${currentOSSAccessory.dil_oss_acc_catentry_id}`,
                    state: { qv: true, extraQVProps: { OSS: currentOSSAccessories } },
                  }}
                >
                  Quick View
                </Link>
              </div>
            ))}
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.fetchOSS();
  }

  fetchOSS(nextProductId, nextDept, nextMic) {
    if (this.props.passedAppFunctions.wasParms.displayOurStylistSuggests == 'true') {
      var axiosOptions = {
        method: 'get',
        url: `/data/oss?catentryId=${nextProductId || this.props.contentData.productId}&dept=${nextDept || this.props.contentData.dept}&mic=${
          nextMic || this.props.contentData.mic
        }`,
      };
      axios(axiosOptions).then((ajaxResponse) => {
        var cmdRespIsJSON;
        var responseJSON = {};
        try {
          responseJSON =
            typeof ajaxResponse.data.contentData == 'object'
              ? ajaxResponse.data.contentData
              : JSON.parse(ajaxResponse.data.contentData);
          cmdRespIsJSON = true;
        } catch (e) {}
        if (cmdRespIsJSON) {
          //update state with the new information
          this.setState({ OSSView: responseJSON });
        } else {
        }
      });
    }
  }
}

export default ProductOurStylistSuggests;
